import styled from "styled-components";
import "@fontsource/lexend";
import "@fontsource/bebas-neue";
import "@fontsource/merriweather";
import "@fontsource/montserrat"; 

export const DesktopOnly = styled.div`
  display: block;
  background: #000;
  padding-bottom: 20px;
  @media (max-width: 768px) {
    display: none;
  }
`;
export const DesktopInlineOnly = styled.span`
  display: inline;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileOnly = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;
export const MobileInlineOnly = styled.span`
  display: none;
  @media (max-width: 768px) {
    display: inline-flex;
  }
`;


export const MobileContainer = styled.div`
  background: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 16px 16px;
  text-align: center;
`;

export const MobileTitle = styled.h2`
  font-family: "Merriweather";
  font-weight: 400;
  color: #fff;
  line-height: 1.3;
  font-size: 26px;
  margin: 0 0 18px;

  @media (max-width: 480px) {
    font-size: ${({ mobileFontSize }) => mobileFontSize || "22px"};
  }
`;

export const MobileVideo = styled.video`
  max-width: 98%;
  width: 100%;
  height: auto;
  border-radius: 24px;
  display: block;
`;